var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 11,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11.725 1.29a.857.857 0 0 0-.278-.215.76.76 0 0 0-.656 0 .858.858 0 0 0-.278.214L4.15 8.588 1.48 5.516a.87.87 0 0 0-.287-.211.775.775 0 0 0-.667.013.881.881 0 0 0-.28.222c-.08.095-.142.206-.184.328a1.13 1.13 0 0 0 .011.765c.046.12.112.23.194.32l3.28 3.758c.079.091.173.164.277.214a.762.762 0 0 0 .657 0 .858.858 0 0 0 .278-.214l6.967-7.983a.987.987 0 0 0 .203-.327 1.102 1.102 0 0 0 0-.785.987.987 0 0 0-.203-.327Z"
})));
export default SvgCheck;